import { useEffect, useState } from 'react';
import Label from "componentsTemplate/Label/Label";
import Select from "componentsTemplate/Select/Select";
import { get } from 'lodash';

const FormFieldSelect = ({
  label,
  fieldName,
  options,
  classe = "block",
  formData,
  handleChange,
  action = null,
  error = null,
}: any) => {
  const [selectedValue, setSelectedValue] = useState(get(formData, fieldName));

  useEffect(() => {
    setSelectedValue(get(formData, fieldName));
  }, [options]);

  return (
    <label className={classe} key={JSON.stringify(options)}>
      <Label>{label}</Label>

      <Select
        className="mt-1"
        style={{ borderRadius: "9999px" }}
        value={selectedValue}
        onChange={(e) => {
          handleChange(fieldName, e.target.value);
          setSelectedValue(e.target.value);
          if (action != null) {
            action(e.target.value);
          }
        }}
        // colocar todos os atributos restantes
      >
        <option value="">Selecione</option>
        {options.map((option: any, index: number) => (
          <option key={index} value={option.value}>
            {option.label}
          </option>
        ))}
      </Select>
      {error && <span className="text-red-500 text-sm">{error}</span>}
    </label>
  );
};

export default FormFieldSelect;